module.exports = __webpack_public_path__ + "static/assets/61a92fe57d8945caa65799880b59afbd.svg";